// src/components/XpWidget.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function XpWidget({ stats, onLevelClick }) {
  const [isExpanded, setIsExpanded] = useState(false); // Состояние для "раскрытия"

  if (!stats) return null;

  const { level, rank, totalXp, progress, xpForCurrentLevel, xpForNextLevel, voiceMinutes, messageCount, bonusXp } = stats;

  // Конвертируем минуты в часы и минуты для красивого отображения
  const voiceHours = Math.floor(voiceMinutes / 60);
  const remainingMinutes = voiceMinutes % 60;

  return (
    // Добавляем обработчик клика на весь виджет
    <div className="xp-widget card"  onClick={() => setIsExpanded(!isExpanded)}>
      <div className="xp-widget-header">
        <div className="level-display">
          <span>Уровень</span>
          <div className="level-circle" onClick={onLevelClick} title="Посмотреть таблицу уровней">{level}</div>
        </div>
        <div className="rank-display">
          <span>Ранг</span>
          <div className="rank-value">#{rank}</div>
        </div>
      </div>

      <div className="xp-bar-container">
        <div className="xp-bar" style={{ width: `${progress}%` }}></div>
      </div>
      <div className="xp-values">
        <span>{totalXp - xpForCurrentLevel} / {xpForNextLevel - xpForCurrentLevel} XP</span>
        <span className="total-xp">Всего: {totalXp} XP</span>
      </div>

      {/* --- НОВЫЙ БЛОК: Детальная статистика (появляется при клике) --- */}
      {isExpanded && (
        <div className="xp-details">
          <div className="detail-item">
            <span className="detail-label">Время в войсе: </span>
            <span className="detail-value">{voiceHours} ч {remainingMinutes} мин</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Сообщений: </span>
            <span className="detail-value">{messageCount}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Бонусный опыт: </span>
            <span className="detail-value">{bonusXp} XP</span>
          </div>
        </div>
      )}


      <Link to="/leaderboard-xp" className="xp-leaderboard-link">Лидерборд по опыту</Link>
    </div>
  );
}